import { PassKinds } from '../enums/PassKinds'
import { ApiClient } from '../helpers/api-client/ApiClient'

export default {
  methods: {
    checkActionClosedPersonals(action) {
      return parseInt(action.check_closed_users) === 0 || (
        parseInt(action.check_closed_users) === 1 &&
        this.application.visitorsCloseCount !== this.application.visitorsPersonalsCount
      )
    },

    checkActionClosedTransports(action) {
      return parseInt(action.check_closed_transports) === 0 || (
        parseInt(action.check_closed_transports) === 1 &&
        this.application.transportsCloseCount !== this.application.transportsCount
      )
    },

    checkActionClosedVisitors(action) {
      if (this.application.pass_kind === PassKinds.TRANSPORT) {
        return this.checkActionClosedTransports(action)
      } else {
        return this.checkActionClosedPersonals(action)
      }
    },

    checkActionOwner(action) {
      return (action.check_owner === 'all' ||
        (action.check_owner === 'own' && parseInt(this.application.user_id) === parseInt(this.user.id)) ||
        (action.check_owner === 'other' && parseInt(this.application.user_id) !== parseInt(this.user.id))) ||
        (parseInt(action.check_user_subdivision) === 1 && this.user.organizationSubdivisions.includes(String(this.application.organization_subdivision_id)))
    },

    checkActionSubdivision(action) {
      return parseInt(action.check_subdivision) === 0 ||
        (parseInt(action.check_subdivision) === 1 && this.equalSubdivisions)
    },

    openPdfInNewTab(pdfPassBlob) {
      window.open(
        URL.createObjectURL(pdfPassBlob),
        '_blank'
      )
    },

    async sendScudXml($event, requireTransport = true) {
      $event.target.disabled = true
      ApiClient.sendToScud({
        appId: this.applicationId ? parseInt(this.applicationId) : null,
        visitorId: this.personalId ? parseInt(this.personalId) : null,
        transportId: this.transportId ? parseInt(this.transportId) : null,
        requireTransport: !!requireTransport
      })
        .then((result) => {
          if (result.data.status === 'success') {
            this.visitor.transports[this.transportIndex].inScud = true
          } else if (result.data.status === 'fail') {
            alert(result.data.message ?? 'Не удалось передать в СКУД')
          }
          $event.target.disabled = false
        })
    },

    async sendSolvoXml() {
      await ApiClient.sendVisitorToSolvo(
        {
          visitorId: this.personalId,
          appId: this.applicationId
        })
        .then(function(result) {
          if (result.data.http_code === 200 && result.data.status === 'success') {
            alert('Заявка успешно передана в Solvo.TOS')
          } else {
            alert('Не удалось передать в Solvo.TOS')
          }
        }).catch(function(xhr) {
          console.log(xhr, this.personalId)
        })
    },

    async setZIndex(bvEvent) {
      const dropDown = document.getElementById(bvEvent.componentId)
      dropDown.style.zIndex = '2'
    },

    showMenuItem(action) {
      return Boolean(
        this.checkActionOwner(action) &&
        this.checkActionSubdivision(action) &&
        this.checkActionClosedVisitors(action)
      )
    },

    unsetZIndex(bvEvent) {
      const dropDown = document.getElementById(bvEvent.componentId)
      dropDown.style.zIndex = '1'
    }
  }
}
